import useUserStore from "@store/useUserStore";
import useSystemStore from "@store/useSystemStore";
import { useDebounce } from "@hooks/useDebounce";
import { useMeetingInitialization } from "./hooks/useMeetingInitialization";
import { ActiveScreen } from "@enums/screens.enum";
import ConnectionScreen from "@screens/connect-meridian";
import ConnectionIssueScreen from "@screens/connection-issue";
import SyncMeetingScreen from "@screens/sync-meeting";
import MeetingScreen from "@screens/meeting";
import { TransitionWrapper } from "@ui/Transition";
import { AppLoader } from "@ui/Loaders";

export function MeetingScreenManager() {
  const { hasSession } = useUserStore();

  useMeetingInitialization(hasSession);

  const { isAppLoading, isAppOffline, activeScreen } = useSystemStore();
  const debouncedIsOffline = useDebounce(isAppOffline, 500);

  if (debouncedIsOffline) return <ConnectionIssueScreen isVisible={isAppOffline} />;

  if (isAppLoading) return <AppLoader />;

  const getScreen = () => {
    switch (activeScreen) {
      case ActiveScreen.LOADING:
        return <AppLoader />;
      case ActiveScreen.CONNECT:
        return <ConnectionScreen />;
      case ActiveScreen.SYNC_MEETING:
        return <SyncMeetingScreen />;
      case ActiveScreen.MEETING:
        return <MeetingScreen />;
      default:
        return <AppLoader />;
    }
  };

  return <TransitionWrapper screenKey={activeScreen}>{getScreen()}</TransitionWrapper>;
}
